import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-inverter-gain',
  templateUrl: './add-inverter-gain.component.html',
  styleUrls: ['./add-inverter-gain.component.scss']
})
export class AddInverterGainComponent implements OnInit {
  gainDetailsForm: FormGroup;
  subDeviceList: any;
  isEditing: any;
  editUserObject: any = {};
  userId: any;
  editMakeId: any;
  dataObject: any = [];
  editSubDeviceId: any;
  editParamName: any;
  role: any;
  roleName: any;
  @HostListener('getAllSubDevices')
  private ResponseVerifiedGetAllDevices: Subject<any> = new Subject();
  constructor(private fb: FormBuilder, private router: Router,
    private route: ActivatedRoute, private dashbord: DashboardService, private toastr: ToastrService, private modalService1: NgbModal) {
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    }else if(this.role == '5'){
      this.roleName = 'slave_admin';
    }
    this.route.queryParams.subscribe(params => {
      if (params.id) {
        this.isEditing = true;
        this.userId = params.id;
      }
    });
  }

  ngOnInit() {

    if (this.roleName == 'admin' && this.isEditing == true) {
      this.getInfoByGainId();
    }else if (this.roleName == 'slave_admin' && this.isEditing == true) {
      this.getInfoByGainId();
    }
    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllSubDevices();
    }
    this.gainDetailsForm = this.fb.group({
      manufacturer_name: ['', [Validators.required, Validators.pattern("^[#.0-9a-zA-Z\s,-_@`~!%^&*()_+-=?<>${}[]|\/]+$")]],
      make_id: ['', [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,6})?$")]],
      sub_device_type_id: ['', Validators.required]
    })

  }
  get f() { return this.gainDetailsForm.controls; }
  onSlaveChange(epc) {
  }

  // get drop down list option values
  getAllSubDevices() {

    this.dashbord.getAllSubDeviceByAdmin()
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices))
      .subscribe(
        async data => {
          if (data.status) {
            this.subDeviceList = data.resultObject;

          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  // add gain details
  addGain() {
    var gainInfo =
    {
      "manufacturer_name": this.gainDetailsForm.controls['manufacturer_name'].value,
      "make_id": this.gainDetailsForm.controls['make_id'].value,
      "sub_device_type_id": this.gainDetailsForm.controls['sub_device_type_id'].value,
    }
    this.dashbord.addInverterGain(gainInfo)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['inject-solar/inverter-gain-table']);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }

  // update gain details
  public showModal(StringPopup) {
    this.modalService1.open(StringPopup, {
      size: <any>'xl', backdrop: 'static',
      keyboard: false
    });
  }

  updateGain() {
    var gainInfo =
    {
      "id": this.userId,
      "manufacturer_name": this.gainDetailsForm.controls['manufacturer_name'].value,
      "make_id": this.gainDetailsForm.controls['make_id'].value,
      "sub_device_type_id": this.gainDetailsForm.controls['sub_device_type_id'].value,
    }
    this.dashbord.updateMakeId(gainInfo).pipe(takeUntil(this.ResponseVerifiedGetAllDevices))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['inject-solar/inverter-gain-table']);
        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);
          } else {
            this.toastr.info(data.message);
          }
        }
      },
        err => {
          return console.log(err);
        })
  }


  getInfoByGainId() {
    this.editUserObject = {
      id: this.userId
    };
    this.dashbord.getInfoByMakeId(this.editUserObject)
      .pipe(takeUntil(this.ResponseVerifiedGetAllDevices))
      .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.dataObject = data.resultObject;
            this.editParamName = this.dataObject.name;
            this.editMakeId = this.dataObject.make_id;
            this.editSubDeviceId = this.dataObject.sub_device_type_id;
            this.gainDetailsForm.get('manufacturer_name').setValue(this.editParamName);
            this.gainDetailsForm.get('make_id').setValue(this.editMakeId);
            this.gainDetailsForm.get('sub_device_type_id').setValue(this.editSubDeviceId);
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);
            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  ngOnDestroy() {
    this.ResponseVerifiedGetAllDevices.next();
    this.ResponseVerifiedGetAllDevices.complete();
  }

}
